import ApiNode from "./ApiNode";

export default {
  getClientWiseTeus(payload = {}) {
    return ApiNode().post("client/get-clientwise-teus", payload);
  },
};




// WEBPACK FOOTER //
// ./src/services/ClientTeusService.js